// ************************************************************************************************
// pathname: /v1/my-jobs/{jobSlug}/instant-activate
// ************************************************************************************************
import { useTranslation } from 'next-i18next';
import { useSwrMutationApi } from '@hooks/useSwrApi';
import { ApiRequestBody } from '@type/api/apiUtilityFn';

/** Hook props */
type UseSwrInstantlyActivateJobReqBody = ApiRequestBody<'/v1/my-jobs/{jobSlug}/instant-activate', 'post'>;
interface UseSwrInstantlyActivateJobProps {
  locale?: Locale;
  jobSlug: string;
  onSuccess?: () => void;
}

/**
 * @description Hook for activating a job.
 * - `locale`: The current app locale.
 * - `jobSlug`: The job slug.
 * - `onSuccess`: Optional callback to execute on success.
 */
export const useSwrInstantlyActivateJob = (props: UseSwrInstantlyActivateJobProps) => {
  const { jobSlug, onSuccess } = props;
  const { t, i18n } = useTranslation('common');

  // SWR, activate the job
  return useSwrMutationApi<undefined, UseSwrInstantlyActivateJobReqBody>({
    url: `/v1/my-jobs/${jobSlug}/instant-activate`,
    locale: i18n.language,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess,
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText: t('my-jobs.toast.activate'),
      showErrorToast: true,
    },
  });
};
